import { useEffect, useState } from 'react';
export var useLoadImage = function (url) {
    var _a = useState(true), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(false), isLoaded = _b[0], setIsLoaded = _b[1];
    // useEffect(() => {
    //   try {
    //     fetch(url).then(r => {
    //       if(r.status == 200) {
    //         setIsLoaded(true);
    //       }
    //       setIsLoading(false);
    //     });
    //   } catch (e) {
    //     setIsLoaded(false);
    //     setIsLoading(false);
    //   }
    // });
    useEffect(function () {
        fetch(url)
            .then(function (response) {
            if (!response.ok) {
                setIsLoading(false);
            }
            setIsLoaded(true);
        }).catch(function () { setIsLoaded(false); setIsLoading(false); });
    }, [url]);
    return { isLoading: isLoading, isLoaded: isLoaded };
};
//# sourceMappingURL=useLoadImage.js.map